let _cameFromList = false;

export function setCameFromList(): void {
  _cameFromList = true;
}

export function consumeCameFromList(): boolean {
  const val = _cameFromList;
  _cameFromList = false;
  return val;
}
